<template>
  <validation-observer ref="notifyAbsence">
    <div class="mt-2">
      <div class="d-flex">
        <i class="fas fa-info-circle text-orange mr-2 mt-1"></i>
        <p class="font-weight-normal font-18">
          Razón para Notificar Ausencia
        </p>
      </div>
    </div>
    <validation-provider v-slot="{ errors }" slim rules="required">
      <custom-text-area
        show-char-count
        label="Razón:"
        v-model="model.reason"
        :maxlength="3000"
        :error="errors[0]"
        custom-error-msg="La razón es requerida"
        :count-classes="['d-block', 'small-counter', 'text-right']"
        :disabled="isReadOnly"
      />
    </validation-provider>
    <div class="row">
      <div class="col-12 d-flex justify-content-end mt-4">
        <action-button
          type="button"
          :text="isReadOnly ? 'Cerrar' : 'Cancelar'"
          i="fas fa-times-circle"
          variant="outline-danger"
          :class="{ 'mr-2': !isReadOnly }"
          @click="$emit('cancel')"
        />
        <action-button
          v-if="!isReadOnly"
          type="button"
          text="Guardar"
          i="fas fa-save"
          variant="success"
          class="see-details-btn"
          @click="save"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

export default {
  name: 'NotifyAbsence',
  components: {
    CustomTextArea,
    ActionButton,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    reason: {
      type: String,
      default: () => null,
    },
  },
  data: () => ({
    model: { reason: null },
  }),
  mounted() {
    if (this.isReadOnly && this.reason) this.model.reason = this.reason;
  },
  methods: {
    async save() {
      const valid = await this.$refs.notifyAbsence.validate();
      if (!valid) return;

      this.$emit('save', this.model);
    },
  },
};
</script>
